import React, { useState, useEffect } from 'react';
import { FaTrophy, FaDice , FaSchool, FaBook, FaChild, FaGlassCheers, FaGraduationCap, FaChurch, FaEnvelope, FaMapMarkerAlt, FaUsers } from 'react-icons/fa';
import './App.css';
import { applySeo } from './seo';
import { FiTarget } from 'react-icons/fi';

const legalDocuments = [
  {
    id: 'impressum',
    title: 'Impressum',
    sections: [
      {
        heading: 'Anbieter',
        lines: [
          'Brettspielgeister GbR',
          'Inhaber: Julia Dornburg und Marco Dornburg',
          'Im Buchwald 85',
          '63150 Heusenstamm'
        ]
      },
      {
        heading: 'Kontakt',
        paragraphs: ['Telefon: +49 1633541498'],
        email: 'Brettspielgeister@web.de'
      },
      {
        heading: 'Umsatzsteuer',
        paragraphs: ['Nach § 19 UStG umsatzsteuerbefreit.']
      },
      {
        heading: 'Geschäftsführer',
        paragraphs: ['Julia Dornburg, Marco Dornburg']
      },
      {
        heading: 'Redaktionell verantwortlich',
        paragraphs: ['Julia und Marco Dornburg']
      },
      {
        heading: 'Schlichtungsstelle',
        paragraphs: [
          'Erklärung Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle:',
          'Hiermit erklären wir, dass wir zur Teilnahme an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle weder bereit noch verpflichtet sind.'
        ]
      },
      {
        heading: 'Urheberrechte',
        paragraphs: [
          'Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.'
        ]
      },
      {
        heading: 'Rechtshinweise',
        paragraphs: [
          'Alle Inhalte vermitteln lediglich einen unverbindlichen Überblick über die Brettspielgeister GbR. Für die Richtigkeit, Vollständigkeit oder Aktualität der Daten wird keine Gewähr übernommen. Dies betrifft auch die Hyperlinks. Änderungen oder Ergänzungen erfolgen ohne vorherige Ankündigung.'
        ]
      }
    ]
  },
  {
    id: 'datenschutz',
    title: 'Datenschutz',
    sections: [
      {
        heading: 'Datenschutzhinweise',
        paragraphs: [
          'Die Nutzung unserer Webseite ist in der Regel ohne Angabe personenbezogener Daten möglich. Soweit auf unseren Seiten personenbezogene Daten (beispielsweise Name, Anschrift oder E-Mail-Adressen) erhoben werden, erfolgt dies, soweit möglich, stets auf freiwilliger Basis. Diese Daten werden ohne Ihre ausdrückliche Zustimmung nicht an Dritte weitergegeben.',
          'Wir weisen darauf hin, dass die Datenübertragung im Internet (z. B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.',
          'Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten durch Dritte zur Übersendung von nicht ausdrücklich angeforderter Werbung und Informationsmaterialien wird hiermit ausdrücklich widersprochen. Die Betreiber der Seiten behalten sich ausdrücklich rechtliche Schritte im Falle der unverlangten Zusendung von Werbeinformationen, etwa durch Spam-Mails, vor.'
        ]
      },
      {
        heading: 'Haftung',
        paragraphs: [
          'Die verantwortlichen Dienstanbieter bemühen sich im Rahmen des Zumutbaren, auf dieser Webseite vollständige und richtige Informationen einzustellen. Die Dienstanbieter übernehmen aber keine Gewähr für die Vollständigkeit, Richtigkeit und Aktualität der auf dieser Webseite bereitgestellten Informationen.'
        ]
      }
    ]
  },
  {
    id: 'agb',
    title: 'AGB',
    sections: [
      {
        heading: 'Vertragspartner',
        lines: [
          'Julia und Marco Dornburg',
          'Brettspielgeister GbR',
          'Im Buchwald 85',
          '63150 Heusenstamm',
          'E-Mail: brettspielgeister@web.de',
          '-im Folgenden: Brettspielgeister-'
        ]
      },
      {
        heading: 'Allgemeines, Geltungsbereich',
        paragraphs: [
          'Für alle Leistungen der Brettspielgeister gelten neben den Seminarbeschreibungen ausschließlich diese Allgemeinen Geschäftsbedingungen. Bedingungen von Teilnehmenden werden ausdrücklich zurückgewiesen.',
          'Verbraucher:in im Sinne dieser Geschäftsbedingungen ist jede natürliche Person, die ein Rechtsgeschäft zu Zwecken abschließt, die überwiegend weder ihrer gewerblichen noch ihrer selbständigen beruflichen Tätigkeit zugerechnet werden können.'
        ]
      },
      {
        heading: 'Vertragsabschluss, Speicherung, Vertragssprache',
        paragraphs: [
          'Die Darstellung der Kurse in unserem Programm stellt kein rechtlich bindendes Angebot dar, sondern eine Aufforderung an den/die Teilnehmende:n, uns ein verbindliches Angebot zu unterbreiten.',
          'Der/die Teilnehmende gibt per E-Mail oder per Post ein verbindliches Angebot ab. Wir können das Angebot des/der Teilnehmenden innerhalb von 7 Werktagen durch Zusendung einer Bestätigung annehmen.',
          'Oder der Vertragsschluss kommt durch ein Angebot der Brettspielgeister, welches die Teilnehmer:innen schriftlich bestätigen, zustande.',
          'Mündliche Nebenabreden bestehen nicht.',
          'Für Änderungen oder Ergänzungen des Auftrags ist ebenfalls die Schriftform vereinbart.',
          'Teilnehmende können diese AGB auf unserer Webseite www.brettspielgeister.de einsehen. Ferner können sie diese AGB als Dokument ausdrucken und speichern, indem sie die hierzu vorgesehene Funktion ihres Internetbrowsers nutzen. Wir speichern den Vertragstext und senden die Anmeldedaten per E-Mail zu.',
          'Die Vertragssprache ist Deutsch.'
        ]
      },
      {
        heading: 'Preise und Zahlungen',
        paragraphs: [
          'Es gelten die für jedes Seminar einzeln ausgewiesenen Preise. Es handelt sich um Endpreise, die jeweils gültige Umsatzsteuer ist enthalten, soweit die Seminarangebote nicht von der Umsatzsteuerzahlung befreit sind. Dies wird jeweils im Seminarangebot ersichtlich.',
          'Bei der Buchung der Kurse erhalten die Teilnehmenden eine Rechnung, aus der auch der Zahlungstermin hervorgeht.',
          'Die Bezahlung erfolgt per Überweisung auf das von uns angegebene Konto. Rechnungen sind vorbehaltlich eines darin abweichend benannten Zahlungszieles spätestens 14 Tage nach Beginn des Seminars fällig.'
        ]
      },
      {
        heading: 'Rücktrittsrecht der Teilnehmenden',
        paragraphs: [
          'Bei Kursen ist eine kostenlose Stornierung bis zu zwei Monate vor Beginn des Kurses möglich. Die Stornierung muss eindeutig in Textform erfolgen.',
          'Bei einem späteren Rücktritt bis zu zwei Wochen vor Kursbeginn wird eine Ausfallpauschale von 25 % der Kursgebühr erhoben.',
          'Tritt der/die Teilnehmende kurzfristiger als zwei Wochen vor Kursbeginn zurück, werden die vollen Kursgebühren in Rechnung gestellt. Ein Rücktritt von Teilleistungen ist nicht möglich.',
          'Bei mehrteiligen Fortbildungen gilt die oben angeführte Regelung für jeden Kursabschnitt entsprechend.',
          'Bei Inhouse-Fortbildungen und sonstigen Fortbildungen, für die ein gesonderter Vertrag abgeschlossen wird, gelten die darin vertraglich vereinbarten Regeln.',
          'Das Widerrufsrecht sowie die Möglichkeiten zum Rücktritt aus wichtigem Grund werden durch die obigen Einschränkungen nicht berührt. Ein wichtiger Grund liegt nicht in einer Erkrankung oder anderweitigen Verhinderung des/der Teilnehmenden.'
        ]
      },
      {
        heading: 'Rücktritt durch die Seminarveranstalterin',
        paragraphs: [
          'Ein Kurs kann aus wichtigen Gründen, z. B. bei zu geringer Teilnehmendenzahl, bei Ausfall bzw. Erkrankung von Dozent:innen, Ausfall der Veranstaltungsräume oder höherer Gewalt abgesagt werden. Die Brettspielakademie wird die Teilnehmenden so rechtzeitig wie möglich informieren. Muss ausnahmsweise ein Kurs abgesagt werden, versucht die Brettspielgeister, die Teilnehmenden auf andere Seminartermine umzubuchen, sofern die Teilnehmenden damit einverstanden sind. Andernfalls erstattet die Brettspielgeister umgehend die bezahlte Kursgebühr. Weitergehende Ansprüche der Teilnehmenden, insbesondere auf Schadensersatzansprüche gleich welcher Art, sind ausgeschlossen, außer in Fällen vorsätzlichen oder grob fahrlässigen Verhaltens der Angestellten oder sonstigen Erfüllungsgehilfen der Brettspielgeister.'
        ]
      },
      {
        heading: 'Seminarinhalte',
        paragraphs: [
          'Der Inhalt und die Durchführung des jeweiligen Seminars richten sich nach der jeweiligen Seminarbeschreibung, die insoweit Bestandteil dieses Vertrages ist. Die Brettspielgeister sind berechtigt, Inhalt und Ablauf der einzelnen Kurse aus fachlichen Gründen zumutbar ohne Zustimmung der Teilnehmenden abzuändern, sofern dadurch nicht der Kern des vereinbarten Seminars berührt wird.'
        ]
      },
      {
        heading: 'Urheberrechte',
        paragraphs: [
          'Alle ausgegebenen Seminarunterlagen sind urheberrechtlich geschützt. Sie werden dem Teilnehmenden des Seminars zur Nutzung im Rahmen der Veranstaltung persönlich zur Verfügung gestellt. Alle Rechte, auch die der Übersetzung, des Nachdrucks und der Vervielfältigung der Unterlagen oder von Teilen daraus behalten sich die Brettspielgeister vor. Alle Unterlagen, auch auszugsweise, dürfen nicht ohne schriftliche Genehmigung der Brettspielgeister in irgendeiner Form reproduziert, verarbeitet, vervielfältigt, verbreitet oder öffentlich wiedergegeben werden.'
        ]
      },
      {
        heading: 'Zusätzliche Kosten',
        paragraphs: [
          'Grundsätzlich verstehen sich die Preise als reine Seminargebühren ohne Übernachtungs- und Verpflegungskosten. Die Seminarteilnehmenden haben im Falle einer notwendigen Unterbringung und Verpflegung die Kosten hierfür selbst zu tragen. Ansprüche gegen den Seminarveranstalter sind ausgeschlossen.'
        ]
      },
      {
        heading: 'Gewährleistung',
        paragraphs: ['Es gilt die gesetzliche Gewährleistung.']
      },
      {
        heading: 'Haftung für Pflichtverletzung im Übrigen',
        paragraphs: ['Die Auftraggeberin haftet dem Auftraggebenden nur auf Vorsatz und grobe Fahrlässigkeit, außer im Falle von Schäden aus der Verletzung von Leben, Körper und Gesundheit.']
      },
      {
        heading: 'Allgemeines',
        paragraphs: [
          'Gegenüber Unternehmern gilt zusätzlich folgendes: Sollten eine oder mehrere der vorstehenden Bedingungen unwirksam sein oder werden oder eine Lücke enthalten, bleiben die übrigen Bedingungen hiervon unberührt.',
          'Für alle Streitigkeiten gilt ausschließlich das Recht der Bundesrepublik Deutschland.',
          'Stand: 20.08.2026'
        ]
      }
    ]
  }
];

function LegalContent({ document }) {
  return (
    <article className="legal-document" aria-labelledby={`${document.id}-title`}>
      <h1 id={`${document.id}-title`}>{document.title}</h1>
      <div className="legal-document-content">
        {document.sections.map((section, index) => (
          <section className="legal-subsection" key={`${section.heading}-${index}`}>
            <h2>{section.heading}</h2>
            {section.lines && (
              <address>
                {section.lines.map((line) => <span key={line}>{line}</span>)}
              </address>
            )}
            {section.paragraphs && section.paragraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
            {section.email && (
              <a href={`mailto:${section.email}`}>{section.email}</a>
            )}
          </section>
        ))}
      </div>
    </article>
  );
}

function SiteFooter({ onNavigate }) {
  const handleInternalLink = (event, path) => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    onNavigate(event, path);
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <img src="/Logo_Farbverlauf.svg" alt="Brettspielgeister Logo" className="footer-logo" />
        </div>

        <div className="footer-section">
          <h3>Kontakt</h3>
          <p>Julia und Marco Dornburg</p>
          <a href="mailto:Brettspielgeister@web.de">Brettspielgeister@web.de</a>
          <p>Heusenstamm, Deutschland</p>
        </div>

        <div className="footer-section">
          <h3>Unsere Mission</h3>
          <p>Spiele als Bildungsmedium in der kindlichen Förderung zu verankern.</p>
        </div>

        <div className="footer-section">
          <h3>Angebote</h3>
          <p>Schulen & Betreuung</p>
          <p>Bibliotheken</p>
          <p>Kindergärten</p>
          <p>VHS-Kurse</p>
          <p>Events & Veranstaltungen</p>
        </div>

        <div className="footer-section">
          <h3>Rechtliches</h3>
          <a href="/impressum" onClick={(event) => handleInternalLink(event, '/impressum')}>Impressum</a>
          <a href="/datenschutz" onClick={(event) => handleInternalLink(event, '/datenschutz')}>Datenschutz</a>
          <a href="/agb" onClick={(event) => handleInternalLink(event, '/agb')}>AGB</a>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; 2025 Brettspielgeister GbR - Alle Rechte vorbehalten</p>
        <p>Julia und Marco Dornburg</p>
      </div>
    </footer>
  );
}

function LegalPage({ document, onNavigate }) {
  const [navHover, setNavHover] = useState({ left: 0, width: 0, visible: false });

  const handleInternalLink = (event, path) => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    onNavigate(event, path);
  };

  const moveNavHover = (event) => {
    const linkRect = event.currentTarget.getBoundingClientRect();
    const navRect = event.currentTarget.parentElement.getBoundingClientRect();

    setNavHover({
      left: linkRect.left - navRect.left,
      width: linkRect.width,
      visible: true
    });
  };

  const clearNavHover = () => {
    setNavHover((current) => ({ ...current, visible: false }));
  };

  const handleNavBlur = (event) => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      clearNavHover();
    }
  };

  return (
    <div className="App legal-app">
      <a className="skip-link" href="#main-content">Zum Inhalt springen</a>

      <nav className="navbar scrolled legal-navbar" aria-label="Hauptnavigation">
        <div className="nav-container">
          <div
            className={`nav-links legal-nav-links ${navHover.visible ? 'has-hover' : ''}`}
            onMouseLeave={clearNavHover}
            onBlur={handleNavBlur}
          >
            <span
              className="nav-hover-indicator"
              aria-hidden="true"
              style={{
                width: `${navHover.width}px`,
                opacity: navHover.visible ? 1 : 0,
                transform: `translateX(${navHover.left}px)`
              }}
            />
            <a href="/" onClick={(event) => handleInternalLink(event, '/')} onMouseEnter={moveNavHover} onFocus={moveNavHover}>Home</a>
            {legalDocuments.map((item) => (
              <a
                href={`/${item.id}`}
                className={item.id === document.id ? 'active' : ''}
                aria-current={item.id === document.id ? 'page' : undefined}
                key={item.id}
                onClick={(event) => handleInternalLink(event, `/${item.id}`)}
                onMouseEnter={moveNavHover}
                onFocus={moveNavHover}
              >
                {item.title}
              </a>
            ))}
          </div>
        </div>
      </nav>

      <main id="main-content">
        <section className="section legal legal-page">
          <div className="container">
            <LegalContent document={document} />
          </div>
        </section>
      </main>

      <SiteFooter onNavigate={onNavigate} />
    </div>
  );
}

function App({ initialPath } = {}) {
  const [currentPath, setCurrentPath] = useState(() => (initialPath ?? window.location.pathname).replace(/\/+$/, '') || '/');
  const [activeSection, setActiveSection] = useState('home');
  const [isScrolled, setIsScrolled] = useState(false);
  const [navHover, setNavHover] = useState({ left: 0, width: 0, visible: false });
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [formStatus, setFormStatus] = useState('');

  useEffect(() => { applySeo(currentPath); }, [currentPath]);

  const legalDocument = legalDocuments.find((document) => `/${document.id}` === currentPath);

  useEffect(() => {
    const handlePopState = () => {
      setCurrentPath(window.location.pathname.replace(/\/+$/, '') || '/');
      window.scrollTo(0, 0);
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  const navigateTo = (event, path) => {
    if (event) {
      event.preventDefault();
    }

    window.history.pushState({}, '', path);
    setCurrentPath(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);

      // Check which section is currently in view
      const sections = ['home', 'about', 'services', 'contact'];
      const scrollPosition = window.scrollY + window.innerHeight / 3;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const offsetTop = element.offsetTop;
          const offsetBottom = offsetTop + element.offsetHeight;

          if (scrollPosition >= offsetTop && scrollPosition < offsetBottom) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Call once on mount to set initial state
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (section) => {
    setActiveSection(section);
    document.getElementById(section)?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Create mailto link with form data
  const mailtoLink = `mailto:Brettspielgeister@web.de?subject=${encodeURIComponent(formData.subject)}&body=${encodeURIComponent(
      `Name: ${formData.name}\nE-Mail: ${formData.email}\n\nNachricht:\n${formData.message}`
    )}`;
    
    window.location.href = mailtoLink;
    
    setFormStatus('success');
    setFormData({ name: '', email: '', subject: '', message: '' });
    
    setTimeout(() => setFormStatus(''), 3000);
  };

  const moveNavHover = (event) => {
    const buttonRect = event.currentTarget.getBoundingClientRect();
    const navRect = event.currentTarget.parentElement.getBoundingClientRect();

    setNavHover({
      left: buttonRect.left - navRect.left,
      width: buttonRect.width,
      visible: true
    });
  };

  const clearNavHover = () => {
    setNavHover((current) => ({ ...current, visible: false }));
  };

  const handleNavBlur = (event) => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      clearNavHover();
    }
  };

  if (currentPath !== '/' && !legalDocument) {
    return (
      <div className="App legal-app">
        <main className="section legal-page container">
          <h1>Seite nicht gefunden</h1>
          <p>Die gewünschte Seite existiert nicht.</p>
          <a href="/" onClick={(event) => navigateTo(event, '/')}>Zur Startseite</a>
        </main>
        <SiteFooter onNavigate={navigateTo} />
      </div>
    );
  }

  if (legalDocument) {
    return <LegalPage document={legalDocument} onNavigate={navigateTo} />;
  }

  return (
    <div className="App">
      <a className="skip-link" href="#main-content">Zum Inhalt springen</a>

      <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`} aria-label="Hauptnavigation">
        <div className="nav-container">
          <div
            className={`nav-links ${navHover.visible ? 'has-hover' : ''}`}
            onMouseLeave={clearNavHover}
            onBlur={handleNavBlur}
          >
            <span
              className="nav-hover-indicator"
              aria-hidden="true"
              style={{
                width: `${navHover.width}px`,
                opacity: navHover.visible ? 1 : 0,
                transform: `translateX(${navHover.left}px)`
              }}
            />
            <button onClick={() => scrollToSection('home')} onMouseEnter={moveNavHover} onFocus={moveNavHover} className={activeSection === 'home' ? 'active' : ''} aria-pressed={activeSection === 'home'}>
              Home
            </button>
            <button onClick={() => scrollToSection('about')} onMouseEnter={moveNavHover} onFocus={moveNavHover} className={activeSection === 'about' ? 'active' : ''} aria-pressed={activeSection === 'about'}>
              Über uns
            </button>
            <button onClick={() => scrollToSection('services')} onMouseEnter={moveNavHover} onFocus={moveNavHover} className={activeSection === 'services' ? 'active' : ''} aria-pressed={activeSection === 'services'}>
              Angebote
            </button>
            <button onClick={() => scrollToSection('contact')} onMouseEnter={moveNavHover} onFocus={moveNavHover} className={activeSection === 'contact' ? 'active' : ''} aria-pressed={activeSection === 'contact'}>
              Kontakt
            </button>
          </div>
        </div>
      </nav>

      <main id="main-content">
        <section id="home" className="section hero">
          <div className="hero-content">
            <img src="/logo.svg" alt="Brettspielgeister Logo" className="hero-logo" />
            <h1 className="hero-h1">Brettspielgeister GbR</h1>
            <h2 className="hero-h2">Fachkräfte für Gesellschaftsspiele</h2>
            <p className="hero-subtitle">
              Spiele als Bildungsmedium
            </p>
          </div>
        </section>

        <section id="about" className="section about">
          <div className="container">
            <h2>Über uns</h2>
            <div className="quote">
              <p>"Beim Spiel kann man einen Menschen in einer Stunde besser kennenlernen als im Gespräch in einem Jahr."</p>
              <cite>– Plato</cite>
            </div>
            
            <div className="intro-text">
              <div className="intro-card">
                <div className="intro-icon"><FiTarget style={{ color: 'white' }} /></div>
                <p>
                  Wir haben es uns zur Aufgabe gemacht Gesellschaftsspiele in der Pädagogik einzusetzen.
                  Auf <strong>langjährige Erfahrung</strong> im Bereich Spiele können wir zurückgreifen. Spiele eignen sich nicht
                  nur als reine Freizeitbeschäftigung, sondern sind Fördermöglichkeit im Bereich Gefühlskontrolle, 
                  emotionale Entwicklung, Sozialkompetenz und vieles mehr.
                </p>
              </div>

              <div className="intro-highlights">
                <div className="intro-highlight">
                  <div className="intro-icon"><FaTrophy style={{ color: 'white' }} /></div>
                  <div className="highlight-content">
                    <h4>UNESCO Kulturerbe 2025</h4>
                    <p>Die Aufnahme in die Liste zum UNESCO Immaterielles Kulturerbe zeigt, wie wichtig Spiele und das Spielen ist.</p>
                  </div>
                </div>

                <div className="intro-highlight">
                  <div className="intro-icon"><FaDice style={{ color: 'white' }} /></div>
                  <div className="highlight-content">
                    <h4>Über 800 Spiele</h4>
                    <p>Unser Bestand wächst regelmäßig - wir sind immer auf dem neuesten Stand und es ist für jede Gelegenheit etwas dabei.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="team">
              <h3>Julia und Marco Dornburg</h3>
              
              <div className="team-member">
                <h4>Julia Dornburg</h4>
                <p>
                  Arbeitet seit über 25 Jahren in einer Stadtbibliothek und beschäftigt sich neben Büchern, 
                  viel mit Gesellschaftsspielen. Regelmäßige Spieleveranstaltungen für Kinder sind ihr wichtig. 
                  Seit einiger Zeit durchläuft sie Fortbildung zum Einsatz von Spielen als Bildungsmedium. 
                  2024 hat sie die zertifizierte Fortbildung zur <strong>Fachkraft für Gesellschaftsspiele</strong> absolviert.
                </p>
              </div>

              <div className="team-member">
                <h4>Marco Dornburg</h4>
                <p>
                  War 20 Jahre lang Store Manager in einem Spielwarenfachhandel, wo er unter anderem für die 
                  Spiele zuständig war. Er hatte hier Kontakt zu den großen Spieleverlagen und hat sich in dieser 
                  Zeit eingehend mit dem Thema spielen beschäftigt. Genau wie seine Frau Julia hat er den 
                  zertifizierten Lehrgang zur <strong>Fachkraft für Gesellschaftsspiele</strong> absolviert. 
                  Mittlerweile als Betreuer an einer Grundschule, hat er hier erste Versuche unternommen, 
                  Kinder an das Medium Spiele heran zu führen.
                </p>
              </div>

              <p className="team-mission">
                Gemeinsam teilen sie den Traum, Spiele als pädagogisches Lernmittel an Kindergärten, 
                Schulen und Betreuung zu bringen. Denn sie haben an ihren eigenen Kindern feststellen dürfen 
                wie fördernd Spiele für das Leben sein können.
              </p>
            </div>
          </div>
        </section>

        <section id="services" className="section services">
          <div className="container">
            <h2>Unsere Angebote</h2>
            
            <div className="services-grid">
              <div className="service-card">
                <div className="service-icon"><FaSchool style={{ color: 'white' }} /></div>
                <h3>Schulen & Betreuung</h3>
                <p>Wie kann das Spielen in Klassenstärke gelingen, welche Spiele eignen sich, welche Kompetenzen werden gefördert, welche Fördermöglichkeiten gibt es und ganz viel praktische Erfahrung wartet auf Sie.</p>
              </div>

              <div className="service-card">
                <div className="service-icon"><FaBook style={{ color: 'white' }} /></div>
                <h3>Bibliotheken</h3>
                <p>Auch gehören Gesellschaftsspiele als Bildungsmedium an Bibliotheken. Wir kommen zu Veranstaltungen, erklären Spiele und geben Tipps für den Medienbestand. Mit über 25-jähriger Berufserfahrung mit Gesellschaftsspielen kennen wir uns aus.</p>
              </div>

              <div className="service-card">
                <div className="service-icon"><FaChild style={{ color: 'white' }} /></div>
                <h3>Kindergärten</h3>
                <p>Wir schauen uns die altersgerechten Spiele vom Kleinkind bis zur Vorschule an, welche Kompetenzen gefördert werden und wie sie im Alltag eingesetzt werden können.</p>
              </div>

              <div className="service-card">
                <div className="service-icon"><FaGlassCheers style={{ color: 'white' }} /></div>
                <h3>Events</h3>
                <p>Mit einer Auswahl an über 800 Spielen haben wir für jede Feier etwas dabei. Ob Großspiele, Rätselspiele, Turniere oder Geschicklichkeitsspiele für viele Gelegenheiten.</p>
              </div>

              <div className="service-card">
                <div className="service-icon"><FaGraduationCap style={{ color: 'white' }} /></div>
                <h3>VHS-Kurse</h3>
                <p>Wir geben Kurse an der VHS zum Thema Gesellschaftsspiele.</p>
              </div>

              <div className="service-card">
                <div className="service-icon"><FaChurch style={{ color: 'white' }} /></div>
                <h3>Kirchen-Events</h3>
                <p>Mehrmals pro Jahr ein Spiele-Event mit der evangelischen Kirche Heusenstamm.</p>
              </div>
            </div>

            <div className="highlights">
              <div className="highlight-box">
                <h3>Über 800 Spiele</h3>
                <p>Unser Bestand wächst regelmäßig - für jede Gelegenheit ist etwas dabei!</p>
              </div>
              <div className="highlight-box">
                <h3>Über 10 Jahre Erfahrung</h3>
                <p>Auf langjährige Erfahrung mit Gesellschaftsspielen können wir zurückgreifen - bei Ihnen vor Ort.</p>
              </div>
            </div>
          </div>
        </section>

        <section id="contact" className="section contact">
          <div className="container">
            <h2>Kontakt aufnehmen</h2>
            <p className="contact-intro">
              Interesse an unseren Angeboten? Schreibt uns eine Nachricht und wir melden uns zeitnah bei euch!
            </p>
            
            <div className="contact-wrapper">
              <div className="contact-form-container">
                <h3>Nachricht senden</h3>
                <form onSubmit={handleSubmit} className="contact-form">
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="name">Name *</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                        autoComplete="name"
                        placeholder="Ihr Name"
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="email">E-Mail *</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        autoComplete="email"
                        placeholder="du@beispiel.de"
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="subject">Betreff *</label>
                    <input
                      type="text"
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleInputChange}
                      required
                      placeholder="Worum geht es?"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="message">Nachricht *</label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleInputChange}
                      required
                      rows="6"
                      placeholder="Ihre Nachricht an uns..."
                    ></textarea>
                  </div>

                  <button type="submit" className="submit-button">
                    Nachricht senden
                  </button>

                  {formStatus === 'success' && (
                    <p className="form-success" role="status">Ihr E-Mail-Programm wurde geöffnet!</p>
                  )}
                </form>
              </div>

              <div className="contact-info-side">
                <h3>Kontaktinformationen</h3>
                <div className="contact-details">
                  <div className="contact-detail-item">
                    <div className="detail-icon"><FaEnvelope style={{ color: 'white' }} /></div>
                    <div>
                      <h4>E-Mail</h4>
                      <a href="mailto:Brettspielgeister@web.de">Brettspielgeister@web.de</a>
                    </div>
                  </div>

                  <div className="contact-detail-item">
                    <div className="detail-icon"><FaMapMarkerAlt style={{ color: 'white' }} /></div>
                    <div>
                      <h4>Standort</h4>
                      <p>Heusenstamm, Deutschland</p>
                    </div>
                  </div>

                  <div className="contact-detail-item">
                    <div className="detail-icon"><FaUsers style={{ color: 'white' }} /></div>
                    <div>
                      <h4>Ansprechpartner</h4>
                      <p>Julia und Marco Dornburg</p>
                    </div>
                  </div>

                  <div className="contact-detail-item">
                    <div className="detail-icon"><FaDice  style={{ color: 'white' }} /></div>
                    <div>
                      <h4>Unsere Expertise</h4>
                      <p>Zertifizierte Fachkräfte für Gesellschaftsspiele</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

      </main>

      <SiteFooter onNavigate={navigateTo} />
    </div>
  );
}

export default App;
